import script from "./OnboardingBondsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingBondsSection.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingBondsSection.vue?vue&type=style&index=0&id=5e6e8e0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e6e8e0e"]])

export default __exports__